import { render, staticRenderFns } from "./informacion_fromulario.vue?vue&type=template&id=8c2c70b0&scoped=true"
import script from "./informacion_fromulario.vue?vue&type=script&lang=js"
export * from "./informacion_fromulario.vue?vue&type=script&lang=js"
import style0 from "./informacion_fromulario.vue?vue&type=style&index=0&id=8c2c70b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2c70b0",
  null
  
)

export default component.exports